import * as qs from 'qs';

export const getQueryString = (
	obj?: any,
	options?: qs.IStringifyOptions<qs.BooleanOptional>
) =>
	qs.stringify(
		{
			sort: ['priority:desc'],
			...obj,
		},
		{
			encodeValuesOnly: true, // This will ensure a clean query string
			...options,
		}
	);
